<template>
  <div class="back_and_close" v-if="isShow">
    <!--<img class="pic1" @click="goBack" :src="back">-->
    <img class="pic2" @click="closeWindow" :src="close">
  </div>
</template>

<script>
  import back from '@/assets/images/back-mobile.png'
  import close from '@/assets/images/36px.png'

  export default {
    data () {
      return {
        back,
        close,
        isShow: false
      }
    },
    created () {
      var ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf('yicbridge') !== -1) {
        this.isShow = true
      }
    },
    methods: {
      closeWindow () {
        this.goBack()
        window.yicbridge.quit()
      },
      goBack () {
        window.yicbridge.close()
      }
    }
  }
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>
  .back_and_close {
    position: absolute;
    left: .3rem;
    top: .1rem;
    z-index: 10000;
  }

  .pic1 {
    height: .32rem;
    width: .2rem;
    margin-right: .2rem;
  }
  .pic2 {
    height: .29rem;
    width: .26rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/backAndClose.vue